import React from 'react';
import useTranslation from "~/app/hooks/useTranslation";
import classes from "./style.module.scss";
import { useStoreState } from '~/store';
import { ServiceStatuses } from '~/app/data/statuses/services';
import Icon from '~/app/common/Icon';
import useAccessControl from '~/app/hooks/useAccessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';

export type HeaderComponent = React.FC<{ isWorkOrderChecklist?: boolean }>

const Header: HeaderComponent = ({ isWorkOrderChecklist = false }) => {
    const { t } = useTranslation("serviceChecklist");
    const hasSimplifiedWorkorder = useStoreState(state => state.service.hasSimplifiedWorkorder ?? false);
    const status = useStoreState(state => state.service.data.status);
    const isCompletedService = [ServiceStatuses.CANCELLED, ServiceStatuses.COMPLETED, ServiceStatuses.PARTIALLLYCOMPLETED].includes(status);

    const { checkPermission } = useAccessControl();
    const writeServiceDetailsPermission = checkPermission(PERMISSION_GROUPS.writeServiceDetails);

    let message = null;
    if (isCompletedService) {
        message = t("canNotEditStatus");
    } else if (!hasSimplifiedWorkorder && !isWorkOrderChecklist) {
        message = t("canNotEditDepartmentPermission");
    } else if (!writeServiceDetailsPermission && !isWorkOrderChecklist) {
        message = t("canNotEditPermission");
    }

    return (
        <div className={classes['header']}>
            <div className={classes['title']}>{t('title')}</div>
            {message && 
                <div className={`${classes['error-message']}`}>
                    <Icon name="error_outline" className={classes['icon']} size={20}/>
                    <div className={classes['label']}>{message}</div>
                </div>
            }
        </div>
    );
};

export default Header
